export const appVersion = '1.7.4';

// password configuration
export const specialChars = '!@#$%& *()][}{|,:;<>/?+-_=';
export const numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

export const name = 'Powiat Ropczycko-Sędziszowski';
export const description = 'Portal e-usług związanych z infrastrukturą drogową Powiatu Ropczycko-Sędziszowski';

export const topRightUELogoEnabled = true;

// export const appLogoTopUrl = '/img/Herb_Polski.svg';
// export const appLogoBottomUrl = '/img/icons/godlo-12.svg';

export const appLogoTopUrl = '/img/logo.svg';
export const appLogoBottomUrl = '/img/logo.svg';

export const showFooterEULogotypes = true;

// application configuration

export const applicationSubmittedTo = 'Starostwa Powiatu Ropczycko-Sędziszowskiego';
